<template>
  <div class="listPage">
    <div class="banner">
      <img src="../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">物流&订单管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">出库管理</div>
    </div>

    <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id, item.runstate)"
        >
          <div class="row_one mb">
            <p>订单编号：{{ item.orderno }}</p>
            <p>订单类型：{{ dataItem.ordertypestr }}</p>
            <p>订单所属区域：{{ dataItem.inarea }}</p>
            <p>订单来源渠道：{{ dataItem.channelidstr }}</p>
            <p>订单发货处理方法：{{ dataItem.sendtype }}</p>
          </div>
          <div class="row_one mb">
            <p>
              商品名称：<span>{{ item.newGoods.commodityname }}</span>
              <!-- 商品名称：<span>{{ dataItem.newGoods.cmname }}</span> -->
            </p>
            <div class="txt">
              <p
                v-for="(label, labelIndex) in item.newGoods.attr"
                :key="labelIndex"
              >
                {{ label }}
              </p>
            </div>
            <p>
              发货信息：<span>{{
                item.msgtype == 1 ? "使用订单同一物流信息" : "商品独立物流信息"
              }}</span>
            </p>
            <p>
              商品数量：<span>{{ item.newGoods.num }}</span>
            </p>
            <div class="warehouse flex-rowl">
              <h1>库源信息：</h1>
              <p v-html="item.msg"></p>
            </div>
          </div>
          <div class="row_one mb">
            <p>
              收件人：<span>{{
                item.msgtype == 1 ? dataItem.truename : item.msgman
              }}</span>
            </p>
            <p>
              收件人联系方式：<span>{{
                item.msgtype == 1 ? dataItem.cellphone : item.msglink
              }}</span>
            </p>
            <p>
              物流信息：{{
                item.msgtype == 1 ? dataItem.order_addr : item.msgaddr
              }}
            </p>
          </div>
          <div class="row_one mb">
            <p>
              订单状态：<span>{{ item.runstate }}</span>
            </p>
            <p>
              物流类型：<span>{{ item.runname }}</span>
            </p>
            <p>
              发货物流单号：<span>{{ item.runno }}</span>
            </p>
            <p>
              发货门店：<span>{{ item.shopstr }}</span>
            </p>
          </div>
        </div>
      </template>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getShopWlserviceList, getLogisticsDetail } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDistriWlserviceList",
  data() {
    return {
      isShowTabbar: true,
      qyguid: "",
      keyword: "",
      listTotal: 0,
      orderno: "",
      loading: false,
      dataItem: "",
      dataList: [],
      orderShopList: [],
      wsid: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    formatAttr(date) {
      if (date.indexOf("；") != -1) {
        let splitArr = date.split("；");
        let str1 = "属性标签：" + splitArr[0];
        let str2 = "属性标签值：" + splitArr[1];
        return str1 + "；" + str2;
      } else {
        let str = "属性标签：" + date;
        return str;
      }
      // let splitArr = date.indexOf('；') != -1 ? date.split('；') : date
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.wsid = id;
        this.getLogisticsDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    async getLogisticsDetail(id) {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let res1 = await getLogisticsDetail({ id });
      this.dataItem = res1;
      this.orderno = res1.orderno;

      let res2 = await getShopWlserviceList({ orderno: res1.orderno });
      if (res2.list.length > 0) {
        res2.list.forEach((v) => {
          v.newGoods = JSON.parse(v.goods);
          // v.newGoods.newAttr = JSON.parse(v.newGoods.attr)
        });
        this.dataList = res2.list;
      }

       toast.clear();
    },

    // 物流详情
    handleDetail(id, runstate) {
      if (runstate == "已发货") {
        this.$toast("该商品已发货！");
        return;
      } else {
        this.encryptstringadd(
          "outboundDistriWlserviceEdit",
          {
            id,
            wsid: this.wsid,
          },
          ""
        );
      }
    },

    handleForm(idC) {
      this.encryptstringadd(
        "outboundItemForm",
        { id: this.wsid, idC },
        "_blank"
      );
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params, type) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          if (type != "") {
            window.open(this.$router.resolve({ name, params }).href, "_blank");
          } else {
            this.$router.push({
              name,
              params,
            });
          }
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success("复制成功");
        console.log("=======-===");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("复制失败");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.listPage {
  padding-bottom: 300px;
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    flex-wrap: wrap;
    margin: 70px 70px 60px;
    .item {
      border: 1px solid #d2d2d2;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 19px;
      margin-right: 10px;
      margin-bottom: 20px;
      span {
        width: 40px;
        display: inline-block;
        margin-left: 20px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .order_wrap {
    margin: 40px auto;
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;
        &.mb {
          margin-bottom: 40px;
        }
        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 50px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            &:last-child {
              font-size: 30px;
            }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        .red {
          color: #ee0032;
        }
      }
    }
  }
}
</style>